module.exports = __webpack_public_path__ + "static/media/quick-access-modules.e0ecc887.png";